import React from "react";
import { ClipLoader } from "react-spinners";
import { Constants } from "../../../../common/constants";

export function RemovingThrobber(props: { color?: string }) {
	return (
		<span className="flex items-center">
			<ClipLoader
				size={"1rem"}
				loading={true}
				color={props.color ?? Constants.EMBED_COLOR}
			/>
		</span>
	);
}
